import { getSearchParam } from '@/common/hooks/useSearchParam';
import { BrowserPersistence } from '@/util';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const storage = new BrowserPersistence();

export function useFacebookTracking() {
  const searchParams = useSearchParams();

  useEffect(() => {
    // facebook 相关跟踪
    const utm_source = getSearchParam('utm_source', searchParams);

    if (utm_source) {
      storage.setItem('utm_source', utm_source);
    }
  }, [searchParams]);
}
